import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { SliceComponent } from ".";
export function Slices(_ref) {
  var body = _ref.body;
  return React.createElement(React.Fragment, null, body === null || body === void 0 ? void 0 : body.map(function (slice, i) {
    return React.createElement(SliceComponent, _extends({
      key: i
    }, slice));
  }));
}